import comp from "./DuplicateTemplateModal";
export default comp;
